import { call, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { logSagaErrorMessage, REGULARS } from 'utils';
import { request, IRequestParams } from './request';
import { RequestMethodTypes } from '../models';

export interface IRequestSagaFactoryOptions {
	actionApi?: any;
	url: string;
	logErrorMessage?: string;
	parsePayload?: (p: any) => any;
	parseData?: (params: any, payload?: any) => any;
	method?: RequestMethodTypes;
}

export function replaceHanldebars(str: string, params: Record<string, any>) {
	const exceptions: Record<string, any> = {};
	const resultString: string = str?.replace(REGULARS.handleBars, (key) => {
		const parsedKey = key.slice(2, -2);
		const value = params[parsedKey];

		if (value) {
			exceptions[parsedKey] = null;
		}

		return value;
	});

	const startParams: Record<string, any> = {};
	const parsedParams = Object.entries(params).reduce((acc, [key, value]) => {
		if (!(key in exceptions)) {
			acc[key] = value;
		}

		return acc;
	}, startParams);

	return {
		str: resultString,
		params: parsedParams,
	};
}

export function requestSagaFactory<Payload, Request>(
	options: IRequestSagaFactoryOptions,
) {
	const {
		actionApi,
		url,
		logErrorMessage,
		parsePayload,
		parseData,
		method,
	} = options;
	return function* (
		{ payload }: { type?: string; payload?: Payload },
		quiet?: boolean,
		customOptions?: {
			preventLoading?: boolean;
		},
	) {
		try {
			if (!quiet || !customOptions?.preventLoading)
				yield put(actionApi.loading());
			const resultPayload =
				typeof parsePayload === 'function' ? parsePayload(payload) : payload;
			const opt: IRequestParams = {
				params: resultPayload,
				url,
				method,
			};

			if (url.indexOf('{{') !== -1 && payload) {
				const { str, params } = replaceHanldebars(url, payload);

				opt.params = params as Payload;
				opt.url = str;
			}

			if (resultPayload && 'data' in resultPayload) {
				opt.params = Object.entries(resultPayload).reduce(
					(acc: Record<string, any>, [key, value]) => {
						if (key !== 'data') {
							acc[key] = value;
						}
						return acc;
					},
					{},
				);
				opt.data = resultPayload.data;
			}

			const { data }: AxiosResponse<Request> = yield call(request, opt);
			const parsedData =
				typeof parseData === 'function' ? parseData(data, payload) : data;

			if (!quiet) yield put(actionApi.success(parsedData));
			return parsedData;
		} catch (e) {
			logSagaErrorMessage(logErrorMessage, e);
			if (!quiet) {
				yield put(actionApi.fail(e));
			} else {
				throw e;
			}
		}
	};
}
